module.exports = __webpack_public_path__ + "static/media/money-honey.9e799882.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GameIcon/money-honey.png
// module id = 1361
// module chunks = 1